import axios from "axios";

export default function getAvailableGroupRoles() {
  return new Promise((resolve, reject) => {
    axios
      .get(`/account/api/v1/branch-group/available-role`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
}
